export const FIELD_MAX_LENGTHS = {
  firstName: 60,
  lastName: 60,
  email: 255,
  contact: 15,
  password: 60,
  confirmPassword: 60,
  companyName: 255,
  corporateName: 255,
  address: 255,
  postalCode: 7,
  roleName: 45,
  jobId: 50,
  description: 200,
  jobType: 20,
  truckType: 20,
  startLocation: 255,
  dumpLocation: 255,
  paymentRate: 15,
  paymentType: 10,
  trucksRequired: 11,
  latitude: 100,
  longitude: 100,
  ajustment:6,
};
export const VALID_JOB_TYPES = ['Paving', 'Dirt Hauling', 'Gravel Supply'];
export const VALID_TRUCK_TYPES = ['Tri-Axle Dump Truck'];
export const VALID_PAYMENT_TYPES = ['Ton', 'Load', 'Hour'];

export const OTP_EXPIRY_TIME_SECONDS = 120;

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const DATE_FORMAT = "MM-DD-YYYY";
export const DATE_TIME_FORMAT = "MM-DD-YYYY HH:mm";
export const DATE_TIME_FORMAT_DTP = "YYYY-MM-DDTHH:mm";
export const DATE_MONTH_FORMAT = "MM-dd-yyyy"

export const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export const TRUCK_DOCS_DOWNLOAD_PATH = `${SERVER_BASE_URL}/downloads/truck_documents`;
